export const MOCO_SETTINGS_FIELDS = [
    { key: 'baseUrl', label: 'Base-URL', type: 'text', group: 'Verbindung', requiresRestart: false },
    { key: 'apiToken', label: 'API-Token', type: 'password', group: 'Verbindung', requiresRestart: false },
    { key: 'connectTimeoutMillis', label: 'Connect-Timeout (ms)', type: 'number', group: 'Timeouts & Rate', requiresRestart: true },
    { key: 'readTimeoutMillis', label: 'Read-Timeout (ms)', type: 'number', group: 'Timeouts & Rate', requiresRestart: true },
    { key: 'requestsPerSecond', label: 'Requests/Sekunde', type: 'number', group: 'Timeouts & Rate', requiresRestart: true },
    { key: 'maxRetries', label: 'Max. Retries', type: 'number', group: 'Timeouts & Rate', requiresRestart: true },
    { key: 'retryBackoffBaseMillis', label: 'Retry-Backoff (ms)', type: 'number', group: 'Timeouts & Rate', requiresRestart: true },
    { key: 'includeArchived', label: 'Archivierte einbeziehen', type: 'checkbox', group: 'Filter & IDs', requiresRestart: false },
    { key: 'syncCompanyTag', label: 'Sync-Company-Tag', type: 'text', group: 'Filter & IDs', requiresRestart: false },
    { key: 'defaultMediaProductionUserId', label: 'Default Media-Production-User-ID', type: 'number', group: 'Filter & IDs', requiresRestart: false },
    { key: 'defaultAdminUserId', label: 'Default Admin-User-ID', type: 'number', group: 'Filter & IDs', requiresRestart: false },
    { key: 'systemCompanyId', label: 'System-Company-ID', type: 'number', group: 'Filter & IDs', requiresRestart: false },
    { key: 'defaultCountryId', label: 'Default Country-ID', type: 'number', group: 'Filter & IDs', requiresRestart: false },
    { key: 'mediaProductionUserPropertyName', label: 'Media-Production-Property', type: 'text', group: 'Property-Namen', requiresRestart: false },
    { key: 'dataDeliveryEmailPropertyName', label: 'Data-Delivery-E-Mail-Property', type: 'text', group: 'Property-Namen', requiresRestart: false },
]

const NUMERIC_KEYS = MOCO_SETTINGS_FIELDS
    .filter(field => field.type === 'number')
    .map(field => field.key)

export function group_settings_fields(fields = MOCO_SETTINGS_FIELDS) {
    return fields.reduce((groups, field) => {
        if (!groups[field.group]) {
            groups[field.group] = []
        }
        groups[field.group].push(field)
        return groups
    }, {})
}

export function normalize_settings(settings = {}) {
    const result = { ...settings }
    NUMERIC_KEYS.forEach(key => {
        const value = result[key]
        result[key] = (value === '' || value === null || value === undefined) ? 0 : Number(value)
    })
    return result
}
